/*
 * L.CircleEditor is an editable extension of L.Circle
 * Based on https://github.com/kartena/Leaflet.EditableHandlers
 with a few modifications
 */

import L from 'leaflet'

export default L.Circle.extend({

  options: {
    icon: new L.DivIcon({
      // iconSize: new L.Point(8, 8),
      iconSize: null,
      className: 'marker-edit-center-icon marker-edit-icon leaflet-div-icon leaflet-editing-icon'
    }),
    iconEdit: new L.DivIcon({
      // iconSize: new L.Point(8, 8),
      iconSize: null,
      className: 'marker-edit-resize-icon marker-edit-icon leaflet-div-icon leaflet-editing-icon'
    }),
    extendedIconClass: 'extend-icon',
    overlappingIconClass: 'overlapping'
  },

  onAdd: function (map) {
    L.Path.prototype.onAdd.call(this, map)

    this.addHooks()
  },

  onRemove: function (map) {
    this.removeHooks()

    L.Path.prototype.onRemove.call(this, map)
  },

  addHooks: function () {
    if (this._map) {
      if (!this._markerGroup) {
        this._initMarkers()
      }
      this._map.addLayer(this._markerGroup)
    }
  },

  removeHooks: function () {
    if (this._map) {
      this._map.removeLayer(this._markerGroup)
      delete this._markerGroup
      delete this._markers
    }
  },

  resetMarkers: function () {
    this.removeHooks()
    this.addHooks()
    this.detectOverlappingMakers()
  },

  updateMarkers: function () {
    this._markerGroup.clearLayers()
    this._initMarkers()
  },

  _initMarkers: function () {
    this._markerGroup = new L.LayerGroup()
    this._markers = []

    var markerCenter = this._createMarker(this._latlng, 0, true, 'icon')
    this._markers.push(markerCenter)

    var circleBounds = this.getBounds()
    var center = circleBounds.getCenter()
    var neCoord = circleBounds.getNorthEast()
    var northCenterCoord = new L.LatLng(center.lat, neCoord.lng, true)
    var markerNorthCenter = this._createMarker(northCenterCoord, 1, false, 'iconEdit')
    this._markers.push(markerNorthCenter)
  },

  _createMarker: function (latlng, index, isCenter, icon) {
    if (isCenter === undefined) {
      isCenter = false
    }

    // put the center marker above the resize gizmo
    var zoffset = isCenter ? 1000 : 0

    var marker = new L.Marker(latlng, {
      draggable: true,
      icon: this.options[icon],
      zIndexOffset: zoffset
    })

    // console.log("this is center point: " + isCenter);

    marker._origLatLng = latlng
    marker._index = index
    marker._isCenter = isCenter

    if (isCenter) {
      marker.on('drag', this._onCenterMove, this)
        .on('dragend', this._onCenterMoveEnd, this)
    } else {
      marker.on('drag', this._onMarkerDrag, this)
    }
    marker.on('dragend', this._fireEdit, this)
      .on('mouseover', this._onMouseOver, this)
      .on('mouseout', this._onMouseOut, this)

    this._markerGroup.addLayer(marker)

    return marker
  },
  _onMouseOver: function (e) {
    var target = e.target
    var icon = target._icon
    var classValues = icon.getAttribute('class')
    // icon.setAttribute("class", "extend-icon " + classValues);
    icon.setAttribute('class', this.options.extendedIconClass + ' ' + classValues)
  },
  _onMouseOut: function (e) {
    var target = e.target
    var icon = target._icon
    var classValues = icon.getAttribute('class')
    // icon.setAttribute("class", classValues.replace("extend-icon", ""));
    icon.setAttribute('class', classValues.replace(this.options.extendedIconClass, ''))
  },

  _fireEdit: function () {
    this.fire('edit')
  },

  _onCenterMove: function (e) {
    var marker = e.target
    // console.log("center move - START")

    L.Util.extend(marker._origLatLng, marker._latlng)

    var mm = this._markers[1]
    mm.setOpacity(0.01)

    this.redraw()
    // console.log("END");
  },

  _onCenterMoveEnd: function (e) {
    // var marker = e.target

    // now resetting the side point
    var circleBounds = this.getBounds()
    var center = circleBounds.getCenter()
    var neCoord = circleBounds.getNorthEast()
    var northCenterCoord = new L.LatLng(center.lat, neCoord.lng, true)
    var mm = this._markers[1]
    mm.setLatLng(northCenterCoord)
    mm.setOpacity(1)

    this.fire('centerchange')
  },

  _onMarkerDrag: function (e) {
    var marker = e.target
    // console.log("marker drag - START")
    var center = this._markers[0].getLatLng()
    var axis = marker._latlng
    var distance = center.distanceTo(axis)

    this.setRadius(distance)

    this.redraw()
    // console.log("END")

    this.fire('radiuschange')
  },

  updateRadius: function (radius) {
    this.setRadius(radius)
    this.redraw()
    this.orientGizmo()
    this.detectOverlappingMakers()
  },

  orientGizmo: function () {
    // snap the marker back to the circle if it was released out of the max radius.
    var cm = this._markers[0]
    var gm = this._markers[1]
    var radius = this.getRadius()

    var centerCoords = cm.getLatLng()
    var gizmoCoords = gm.getLatLng()

    // hacky way to get the flat x and y distance, using the Haversine formula
    // todo: see if (project/unproject) from leaflet conversion can be used instead
    var x = new L.LatLng(centerCoords.lat, centerCoords.lng).distanceTo(new L.LatLng(gizmoCoords.lat, centerCoords.lng))
    var y = new L.LatLng(centerCoords.lat, centerCoords.lng).distanceTo(new L.LatLng(centerCoords.lat, gizmoCoords.lng))

    x = x * Math.sign(gizmoCoords.lat - centerCoords.lat)
    y = y * Math.sign(gizmoCoords.lng - centerCoords.lng)

    var a = Math.atan2(y, x)

    var xm = Math.cos(a) * radius
    var ym = Math.sin(a) * radius

    var earth = 6378137

    // convert back into degrees of lat/long
    var newLat = centerCoords.lat + (xm / earth) * (180 / Math.PI)
    var newLng = centerCoords.lng + (ym / earth) * (180 / Math.PI) / Math.cos(centerCoords.lat * Math.PI / 180)

    var newLatLng = new L.LatLng(newLat, newLng, true)

    gm.setLatLng(newLatLng)
    gm._icon.style.transform = gm._icon.style.transform + ' rotate(' + (a + 1.5708) + 'rad)'
    gm.setOpacity(1)
  },

  detectOverlappingMakers: function () {
    var cm = this._markers[0]
    var gm = this._markers[1]

    var cmr = cm._icon.getBoundingClientRect()
    var gmr = gm._icon.getBoundingClientRect()

    var classValues = gm._icon.getAttribute('class')
    classValues = classValues.replace(new RegExp(this.options.overlappingIconClass, 'g'), '')

    if (!(cmr.right < gmr.left || cmr.left > gmr.right || cmr.bottom < gmr.top || cmr.top > gmr.bottom)) {
      gm._icon.setAttribute('class', this.options.overlappingIconClass + ' ' + classValues)
    } else {
      gm._icon.setAttribute('class', classValues)
    }
  },

  centerchange: function () {},
  radiuschange: function () {}
})



// WEBPACK FOOTER //
// ./src/libs/maps/circleEditor.js